import { Controller } from "@hotwired/stimulus"

// Scrolls a horizontally overflowing tab bar so its active tab ([aria-current="page"]) is
// visible. The Stundenzettel tabs overflow next to the sidebar, and the tabs at the end
// (Zeitleiste, Zulagen) would otherwise be active but off-screen. Only scrollLeft changes,
// never the page's vertical scroll position (scrollIntoView would move that too).
export default class extends Controller {
  connect() {
    const active = this.element.querySelector('[aria-current="page"]')
    if (!active) return

    const bar = this.element.getBoundingClientRect()
    const tab = active.getBoundingClientRect()
    if (tab.right > bar.right) {
      this.element.scrollLeft += tab.right - bar.right
    } else if (tab.left < bar.left) {
      this.element.scrollLeft -= bar.left - tab.left
    }
  }
}
